"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onImpressionCounted = void 0;
var helpers_1 = require("../../../helpers");
var getKevelImpressionCPI_1 = __importDefault(require("./getKevelImpressionCPI"));
var getAdTypes_1 = require("./getAdTypes");
var onImpressionCounted = function (msg) {
    var _a, _b, _c, _d;
    var nonAthaZones = [183796];
    var msgData = msg === null || msg === void 0 ? void 0 : msg.data;
    var zoneId = ((_a = msgData === null || msgData === void 0 ? void 0 : msgData.shim) === null || _a === void 0 ? void 0 : _a.zn) ? msgData.shim.zn : "unknown";
    if (nonAthaZones.includes(zoneId)) {
        (0, helpers_1.getCookie)("debug-ads") &&
            console.debug("setupKevelImpressionListener: ".concat(nonAthaZones, " contains the zoneId: ").concat(zoneId));
        return;
    }
    if (typeof window.__atha !== "undefined") {
        var size = "";
        if (msgData === null || msgData === void 0 ? void 0 : msgData.div) {
            var sizeId = (_b = msgData === null || msgData === void 0 ? void 0 : msgData.shim) === null || _b === void 0 ? void 0 : _b.at;
            var placement = msgData === null || msgData === void 0 ? void 0 : msgData.div.split("-")[0];
            if (sizeId) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore sizes has not yet been properly typed out in adzerkHeaderBiddingUnitMap
                var sizes = (0, getAdTypes_1.kevelSizeIdToSize)(sizeId);
                if (sizes) {
                    size = sizes.join("x");
                }
            }
        }
        var price = (0, getKevelImpressionCPI_1.default)(msgData.shim);
        window.__atha.sendImpression(msgData.div || "unknown", zoneId.toString(), ((_d = (_c = msgData === null || msgData === void 0 ? void 0 : msgData.shim) === null || _c === void 0 ? void 0 : _c.fl) === null || _d === void 0 ? void 0 : _d.toString()) || "unknown", price, size);
    }
    else {
        (0, helpers_1.getCookie)("debug-ads") && console.debug("window.__atha is undefined");
    }
};
exports.onImpressionCounted = onImpressionCounted;
var setupKevelImpressionListener = function () {
    window.ados = window.ados || {};
    window.ados.events = window.ados.events || {};
    window.ados.on = function (e, fn) {
        window.ados.events[e] = window.ados.events[e] || [];
        return window.ados.events[e].push(fn);
    };
    window.ads = window.ads || {};
    window.ados.on("ImpressionCounted", exports.onImpressionCounted);
};
exports.default = setupKevelImpressionListener;
